import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useState } from "react";
import Header from "../header/Header";
import Footer from "../footer/Footer";

const Login = () => {
  const navigate = useNavigate();
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      await axios.post("https://dummyjson.com/auth/login", {
        username: userName,
        password,
      });
      navigate("/");
    } catch (error) {
      alert("Invalid credentials. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0F172A] text-[#F8FAFC]">
      <Header />
      <main className="mx-auto max-w-3xl px-6 py-24">
        <section className="glass-panel border-slate-700/60 p-10">
          <div className="mb-8 space-y-2 text-center">
            <p className="text-sm uppercase tracking-[0.4em] text-emerald-300">Member Access</p>
            <h1 className="text-4xl font-semibold text-white sm:text-5xl">Court Booking Login</h1>
            <p className="mx-auto max-w-xl text-slate-300">Secure access to court booking, training schedules and member-only offers.</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <label className="block text-sm font-medium text-slate-200">
              Email address
              <input
                type="email"
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
                required
                className="mt-3 w-full rounded-3xl border border-white/10 bg-slate-950/80 px-4 py-3 text-slate-100 outline-none transition focus:border-emerald-400 focus:ring-2 focus:ring-emerald-400/20"
                placeholder="you@example.com"
              />
            </label>

            <label className="block text-sm font-medium text-slate-200">
              Password
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="mt-3 w-full rounded-3xl border border-white/10 bg-slate-950/80 px-4 py-3 text-slate-100 outline-none transition focus:border-emerald-400 focus:ring-2 focus:ring-emerald-400/20"
                placeholder="Enter your password"
              />
            </label>

            <div className="flex items-center justify-between text-sm text-slate-400">
              <label className="flex items-center gap-2">
                <input type="checkbox" className="h-4 w-4 rounded border-white/30 bg-slate-900 text-emerald-500 focus:ring-emerald-400" />
                Remember me
              </label>
              <button type="button" className="text-emerald-300 hover:text-emerald-200">
                Forgot password?
              </button>
            </div>

            <button
              type="submit"
              className="btn-primary w-full py-3 text-base"
              disabled={loading}
            >
              {loading ? "Signing in..." : "Sign In"}
            </button>
          </form>

          <div className="mt-10 border-t border-white/10 pt-8 text-center text-slate-300">
            <p className="mb-4">Need help booking a court?</p>
            <button
              type="button"
              onClick={() => navigate("/")}
              className="rounded-full border border-slate-700 px-6 py-3 text-sm font-semibold text-slate-100 transition hover:border-emerald-400 hover:text-emerald-300"
            >
              Back to Academy
            </button>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Login;

// const SignIn = () => {
//   const [mobileNumber, setMobileNumber] = useState('');
//   const [otp, setOtp] = useState('');
//   const [verificationId, setVerificationId] = useState('');

//   const handleSendOtp = async () => {
//     try {
//       // Make a POST request to your OTP generation endpoint
//       const response = await axios.post('/api/send-otp', { mobileNumber });

//       // Handle the response (e.g., store the verification ID)
//       setVerificationId(response.data.verificationId);
//       console.log('OTP sent successfully!');
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   const handleSignIn = async () => {
//     try {
//       // Make a POST request to your OTP verification endpoint
//       const response = await axios.post('/api/verify-otp', {
//         verificationId,
//         otp,
//       });

//       // Handle the response (e.g., store user token in local storage)
//       const userToken = response.data.token;
//       console.log('Logged in successfully!');
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   return (
//     <div>
//         <Header/>
//       <h2>Sign In</h2>
//       <div>
//         <label>Mobile Number:</label>
//         <input
//           type="text"
//           value={mobileNumber}
//           onChange={(e) => setMobileNumber(e.target.value)}
//           required
//         />
//       </div>
//       <button onClick={handleSendOtp}>Send OTP</button>

//       <div>
//         <label>OTP:</label>
//         <input
//           type="text"
//           value={otp}
//           onChange={(e) => setOtp(e.target.value)}
//           required
//         />
//       </div>
//       <button onClick={handleSignIn}>Sign In</button>
//       <Gallery/>
//       <Footer/>
//     </div>
//   );
// };

// export default SignIn;
